var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadMoreIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.58892 0.5 0 4.08892 0 8.5C0 12.9111 3.58892 16.5 8 16.5C12.4111 16.5 16 12.9111 16 8.5C16 4.08892 12.4111 0.5 8 0.5ZM8 15.2692C4.26749 15.2692 1.23077 12.2325 1.23077 8.5C1.23077 4.76749 4.26749 1.73077 8 1.73077C11.7325 1.73077 14.7692 4.76749 14.7692 8.5C14.7692 12.2325 11.7325 15.2692 8 15.2692ZM10.8964 7.24379C11.1368 7.4842 11.1368 7.87397 10.8964 8.11438L8.4349 10.5759C8.3151 10.6957 8.15754 10.7564 8 10.7564C7.84246 10.7564 7.6849 10.6965 7.5651 10.5759L5.10357 8.11438C4.86316 7.87397 4.86316 7.4842 5.10357 7.24379C5.34398 7.00338 5.73375 7.00338 5.97416 7.24379L8.0008 9.27043L10.0275 7.24379C10.2671 7.0042 10.656 7.0042 10.8964 7.24379Z",
    fill: "#009EFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadMoreIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/load-more-icon.56d4ec983217a47884b2e1d2f3a9c64c.svg";